module.exports = __webpack_public_path__ + "static/media/star-full.ebd1718e.svg";